import {REQUEST_STATE} from '@/iamteacherpc/consts/request.js';
import multimediaApi from '@/common/apis/common/multimediaApi.js';
import {REQUEST_CANCEL_CODE} from '@/common/apis/api.js';
import {generatekey} from '@/iamteacherpc/utils/key.js';

export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const RETRY_DOCUMENT = 'RETRY_DOCUMENT';

export const mutations = {
    setDocument(state, document) {
        const storedDocumentIndex = state.form.documents.findIndex(d => d.documentKey === document.documentKey);
        if (storedDocumentIndex === -1) {
            state.form.documents.push(document);
            return;
        }

        state.form.documents.splice(storedDocumentIndex, 1, {
            ...state.form.documents[storedDocumentIndex],
            ...document,
        });
    },

    deleteDocument(state, {documentKey}) {
        const storedDocumentIndex = state.form.documents.findIndex(d => d.documentKey === documentKey);
        state.form.documents.splice(storedDocumentIndex, 1);
    },
};

export const actions = {
    /**
     *
     * @param commit
     * @param state
     * @param file
     * @param options
     * @param options.isRetry
     * @param options.documentKey
     */
    [UPLOAD_DOCUMENT]({commit, state}, {file, options = {}}) {
        const documentKey = (options && options.isRetry && options.documentKey) || generatekey({category: 'document'});
        commit('setDocument', {
            documentKey,
            fileName: file.name,
            fileSize: file.size,
            file: file,
            uploadPercent: 0,
            uploadState: REQUEST_STATE.PENDING,
        });

        let objectStorageNo = 0;
        let tokenKey = 0;
        multimediaApi.getUploadToken()
            .then(tokenResponse => {
                tokenKey = tokenResponse.key;
                return multimediaApi.startDocumentUpload({
                    tokenResponse,
                    file,
                    progressCallback(e) {
                        if (!e.lengthComputable) {
                            return;
                        }

                        const percent = (e.loaded / e.total) * 100;
                        commit('setDocument', {uploadPercent: percent, documentKey});
                    },
                    requestCallback({cancel}) {
                        commit('setDocument', {cancel, documentKey});
                    },
                });
            })
            .then(response => {
                objectStorageNo = response.objectStorageNo;
                return multimediaApi.mappingTempDocument({objectStorageNo, key: tokenKey});
            })
            .then(response => {
                commit('setDocument', {
                    documentKey,
                    documentNo: objectStorageNo,
                    uploadState: REQUEST_STATE.SUCCESS,
                    tokenKey,
                });
            })
            .catch(e => {
                if (e.code === REQUEST_CANCEL_CODE) {
                    commit('deleteDocument', {documentKey});
                    return;
                }
                commit('setDocument', {uploadState: REQUEST_STATE.FAIL, documentKey});
            });
    },

    [DELETE_DOCUMENT]({commit, state}, {documentKey}) {
        const storedDocument = state.form.documents.find(d => d.documentKey === documentKey);
        if (storedDocument && storedDocument.uploadState === REQUEST_STATE.PENDING) {
            storedDocument.cancel();
        }

        commit('deleteDocument', {documentKey: storedDocument.documentKey});
    },

    [RETRY_DOCUMENT]({dispatch, state}, {documentKey}) {
        const storedDocument = state.form.documents.find(d => d.documentKey === documentKey);
        if (!storedDocument) {
            return;
        }

        if (storedDocument.uploadState !== REQUEST_STATE.FAIL) {
            return;
        }

        dispatch(UPLOAD_DOCUMENT, {file: storedDocument.file, options: {isRetry: true, documentKey}});
    },
};
